// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock3-commonHeaderAdmin-XYTb8 {
	position: fixed !important;
}

.WhyHostFormBlock3-adminLayout-RQZ0Q {
	padding-top: 64px !important;
}

.WhyHostFormBlock3-box-pfRSR h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostFormBlock3-exportLink-PsLCo {
	margin-bottom: -29px;
}

.WhyHostFormBlock3-blockCenter-NSEvY {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostFormBlock3-panelHeader-PE_mn {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostFormBlock3-currencyselect-gCjU6 {
	width: 100%;
	margin-right: 0px;
}

.WhyHostFormBlock3-panelHeader-PE_mn {
	overflow: hidden;
	position: relative;
}

.WhyHostFormBlock3-mar0-J7iJj {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock3-blockCenter-NSEvY {
		padding: 0px;
	}

	.WhyHostFormBlock3-panelHeader-PE_mn {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostFormBlock3-sideAdminPageWrapper-DUlX1 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostFormBlock3-panelHeader-PE_mn {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostFormBlock3-table-vMoKq {
	display: table;
}

.WhyHostFormBlock3-tableRow-nigdR {
	display: table-row;
}

.WhyHostFormBlock3-tableCell-wNGnH {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock3-formGroup-UGFTS {
	margin-bottom: 6px;
}

.WhyHostFormBlock3-select-cj8L7 {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostFormBlock3-noMargin-DDAOZ {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock3-exportLink-PsLCo {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock3-labelTextNew-jgMzl {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock3-displayInline-VXFK0 {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostFormBlock3-btnUPdate-zGnzn {
	display: inline-block;
}

.WhyHostFormBlock3-btnModalDelete-Suesq {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostFormBlock3-radioBtn-u7uaD {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostFormBlock3-backgroundImg-P_rK4 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock3-btnUPdate-zGnzn {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostFormBlock3-btnModalDelete-Suesq {
		display: block;
		margin-left: 0px;
	}

	.WhyHostFormBlock3-btnWidth-v2AoT {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock3-bannerImageBg-dDd6J {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostFormBlock3-bannerDelete-jQj7O {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostFormBlock3-modalRoot-G6ZDW {
	padding: 32px;
}

.WhyHostFormBlock3-modalBorderBottom-sJOkQ {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostFormBlock3-logInModalBody-BRcvX {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostFormBlock3-exportSection-ousa0 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostFormBlock3-exportSectionGridSub-aikRZ {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock3-exportText-ISEZy {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostFormBlock3-exportLinkImg-PdPnb {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostFormBlock3-vtrMiddle-ul6pu {
	vertical-align: middle;
}

.WhyHostFormBlock3-exportImg-feVnN {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock3-profileViewlabel-jL6Q_ {
	display: inline-block;
	width: 38%
}

.WhyHostFormBlock3-profileViewMainContent-gN8LH {
	display: inline-block;
	width: 62%;
}

.WhyHostFormBlock3-profileViewMain-OP56k {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostFormBlock3-profileViewInner-smWJ7 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock3-profileImageSection-sNhcK {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostFormBlock3-lastviewInner-tZEEn {
	padding: 10px;
}

.WhyHostFormBlock3-whyHostHoriLine-dZOW3 {
	margin: 30px 0;
}

.WhyHostFormBlock3-tableGrid-Lh1KY {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostFormBlock3-headingContent-GKfqW {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostFormBlock3-refundTextColor-GfGNo {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostFormBlock3-dividerLine-CPAbr {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostFormBlock3-smallContent-_2IXD {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostFormBlock3-sideAdminPageWrapper-DUlX1 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostFormBlock3-sideAdminPageWrapper-DUlX1 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostFormBlock3-exportSection-ousa0 {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock3-exportSectionGridSub-aikRZ {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock3-profileViewlabel-jL6Q_ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock3-profileViewMainContent-gN8LH {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostFormBlock3-ChangeToUpperCase-B68Da {
	text-transform: uppercase
}

.WhyHostFormBlock3-noBorder-rzAyu {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostFormBlock3-siteAdminHeading-QYJlb {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock3-siteAdminSubHeading-NFxmd {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock3-adminFormDivider-Bn7OP {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostFormBlock3-errorMessage-IjNED {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostFormBlock3-panelHeader-PE_mn {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock3-formGroup-UGFTS {
  margin-bottom: 6px;
}

.WhyHostFormBlock3-select-cj8L7 {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostFormBlock3-labelText-uWp2a {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostFormBlock3-space1-_Kusn {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock3-space2-nx6QJ {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock3-space3-v4cLw {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock3-space4-IAqke {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock3-space5-AzSHj {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock3-space6-IjPhq {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock3-space7-k9URw {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock3-spaceTop8-dJyQj {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock3-spaceTop1-XkKhj {
	margin-top: 6px !important;
}

.WhyHostFormBlock3-spaceTop2-ipt6T {
	margin-top: 12px !important;
}

.WhyHostFormBlock3-spaceTop3-g08f5 {
	margin-top: 18px !important;
}

.WhyHostFormBlock3-spaceTop4-_SNmR {
	margin-top: 24px !important;
}

.WhyHostFormBlock3-spaceTop5-ia1bY {
	margin-top: 30px !important;
}

.WhyHostFormBlock3-spaceTop6-N2P0Q {
	margin-top: 36px !important;
}

.WhyHostFormBlock3-spaceTop7-c2rja {
	margin-top: 42px !important;
}

.WhyHostFormBlock3-spaceTop8-dJyQj {
	margin-top: 48px !important;
}

.WhyHostFormBlock3-noMargin-DDAOZ {
	margin: 0px !important;
}

.WhyHostFormBlock3-padding1-qeaU0 {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock3-padding2-zTTKT {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock3-padding3-H_rsi {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock3-padding4-lSmz9 {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock3-padding5-QYrWv {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock3-padding6-BJKgH {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock3-padding7-W1lwF {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock3-paddingTop1-H16fA {
	padding-top: 6px !important;
}

.WhyHostFormBlock3-paddingTop2-JtQ0Q {
	padding-top: 12px !important;
}

.WhyHostFormBlock3-paddingTop3-lxMEl {
	padding-top: 18px !important;
}

.WhyHostFormBlock3-paddingTop4-bP84G {
	padding-top: 24px !important;
}

.WhyHostFormBlock3-paddingTop5-NjzhR {
	padding-top: 30px !important;
}

.WhyHostFormBlock3-paddingTop6-E9bYF {
	padding-top: 36px !important;
}

.WhyHostFormBlock3-paddingTop7-SIDDd {
	padding-top: 42px !important;
}

.WhyHostFormBlock3-noPadding-fZ8lb {
	padding: 0px !important;
}

.WhyHostFormBlock3-textBold-imstR {
	font-weight: 500 !important;
}

.WhyHostFormBlock3-textBolder-POxyL {
	font-weight: 700 !important;
}

.WhyHostFormBlock3-textNormal-faXcQ {
	font-weight: normal !important;
}

.WhyHostFormBlock3-spaceBottom20-i35WO {
	margin-bottom: 20px;
}

.WhyHostFormBlock3-spaceBottom10-qkctv {
	margin-bottom: 10px;
}

.WhyHostFormBlock3-marginNone-yl3fj {
	margin: 0;
}

.WhyHostFormBlock3-spaceBottom15-YyWX5 {
	margin-bottom: 15px;
}

.WhyHostFormBlock3-marginTopNone-ipFFt {
	margin-top: 0;
}

.WhyHostFormBlock3-spaceTop11-BvF1R {
	margin-top: 11px;
}

.WhyHostFormBlock3-spaceTop21-OyhP7 {
	margin-top: 21px;
}

.WhyHostFormBlock3-spaceTop20-lXBSx {
	margin-top: 20px;
}

.WhyHostFormBlock3-spaceTop10-j1f5q {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostFormBlock3-textDarkBlue-UtGJV {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock3-textLightBlue-0QoGF {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock3-textLightSandleGreen-gpQhz {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock3-textLightBrown-Xxy31 {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock3-textMediumMaroon-hSArL {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock3-textBrown-kSZ4N {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock3-textMaroon-et11l {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock3-textDarkBrown-C6uVH {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock3-textMediumBrown-PRPod {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock3-textSkyBlue-ok0UF {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock3-textGray-BCcQk {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostFormBlock3-commonHeaderAdmin-XYTb8`,
	"adminLayout": `WhyHostFormBlock3-adminLayout-RQZ0Q`,
	"box": `WhyHostFormBlock3-box-pfRSR`,
	"exportLink": `WhyHostFormBlock3-exportLink-PsLCo`,
	"blockCenter": `WhyHostFormBlock3-blockCenter-NSEvY`,
	"panelHeader": `WhyHostFormBlock3-panelHeader-PE_mn`,
	"currencyselect": `WhyHostFormBlock3-currencyselect-gCjU6`,
	"mar0": `WhyHostFormBlock3-mar0-J7iJj`,
	"sideAdminPageWrapper": `WhyHostFormBlock3-sideAdminPageWrapper-DUlX1`,
	"table": `WhyHostFormBlock3-table-vMoKq`,
	"tableRow": `WhyHostFormBlock3-tableRow-nigdR`,
	"tableCell": `WhyHostFormBlock3-tableCell-wNGnH`,
	"formGroup": `WhyHostFormBlock3-formGroup-UGFTS`,
	"select": `WhyHostFormBlock3-select-cj8L7`,
	"noMargin": `WhyHostFormBlock3-noMargin-DDAOZ`,
	"labelTextNew": `WhyHostFormBlock3-labelTextNew-jgMzl`,
	"displayInline": `WhyHostFormBlock3-displayInline-VXFK0`,
	"btnUPdate": `WhyHostFormBlock3-btnUPdate-zGnzn`,
	"btnModalDelete": `WhyHostFormBlock3-btnModalDelete-Suesq`,
	"radioBtn": `WhyHostFormBlock3-radioBtn-u7uaD`,
	"backgroundImg": `WhyHostFormBlock3-backgroundImg-P_rK4`,
	"btnWidth": `WhyHostFormBlock3-btnWidth-v2AoT`,
	"bannerImageBg": `WhyHostFormBlock3-bannerImageBg-dDd6J`,
	"bannerDelete": `WhyHostFormBlock3-bannerDelete-jQj7O`,
	"modalRoot": `WhyHostFormBlock3-modalRoot-G6ZDW`,
	"modalBorderBottom": `WhyHostFormBlock3-modalBorderBottom-sJOkQ`,
	"logInModalBody": `WhyHostFormBlock3-logInModalBody-BRcvX`,
	"exportSection": `WhyHostFormBlock3-exportSection-ousa0`,
	"exportSectionGridSub": `WhyHostFormBlock3-exportSectionGridSub-aikRZ`,
	"exportText": `WhyHostFormBlock3-exportText-ISEZy`,
	"exportLinkImg": `WhyHostFormBlock3-exportLinkImg-PdPnb`,
	"vtrMiddle": `WhyHostFormBlock3-vtrMiddle-ul6pu`,
	"exportImg": `WhyHostFormBlock3-exportImg-feVnN`,
	"profileViewlabel": `WhyHostFormBlock3-profileViewlabel-jL6Q_`,
	"profileViewMainContent": `WhyHostFormBlock3-profileViewMainContent-gN8LH`,
	"profileViewMain": `WhyHostFormBlock3-profileViewMain-OP56k`,
	"profileViewInner": `WhyHostFormBlock3-profileViewInner-smWJ7`,
	"profileImageSection": `WhyHostFormBlock3-profileImageSection-sNhcK`,
	"lastviewInner": `WhyHostFormBlock3-lastviewInner-tZEEn`,
	"whyHostHoriLine": `WhyHostFormBlock3-whyHostHoriLine-dZOW3`,
	"tableGrid": `WhyHostFormBlock3-tableGrid-Lh1KY`,
	"headingContent": `WhyHostFormBlock3-headingContent-GKfqW`,
	"refundTextColor": `WhyHostFormBlock3-refundTextColor-GfGNo`,
	"dividerLine": `WhyHostFormBlock3-dividerLine-CPAbr`,
	"smallContent": `WhyHostFormBlock3-smallContent-_2IXD`,
	"ChangeToUpperCase": `WhyHostFormBlock3-ChangeToUpperCase-B68Da`,
	"noBorder": `WhyHostFormBlock3-noBorder-rzAyu`,
	"siteAdminHeading": `WhyHostFormBlock3-siteAdminHeading-QYJlb`,
	"siteAdminSubHeading": `WhyHostFormBlock3-siteAdminSubHeading-NFxmd`,
	"adminFormDivider": `WhyHostFormBlock3-adminFormDivider-Bn7OP`,
	"errorMessage": `WhyHostFormBlock3-errorMessage-IjNED`,
	"labelText": `WhyHostFormBlock3-labelText-uWp2a`,
	"space1": `WhyHostFormBlock3-space1-_Kusn`,
	"space2": `WhyHostFormBlock3-space2-nx6QJ`,
	"space3": `WhyHostFormBlock3-space3-v4cLw`,
	"space4": `WhyHostFormBlock3-space4-IAqke`,
	"space5": `WhyHostFormBlock3-space5-AzSHj`,
	"space6": `WhyHostFormBlock3-space6-IjPhq`,
	"space7": `WhyHostFormBlock3-space7-k9URw`,
	"spaceTop8": `WhyHostFormBlock3-spaceTop8-dJyQj`,
	"spaceTop1": `WhyHostFormBlock3-spaceTop1-XkKhj`,
	"spaceTop2": `WhyHostFormBlock3-spaceTop2-ipt6T`,
	"spaceTop3": `WhyHostFormBlock3-spaceTop3-g08f5`,
	"spaceTop4": `WhyHostFormBlock3-spaceTop4-_SNmR`,
	"spaceTop5": `WhyHostFormBlock3-spaceTop5-ia1bY`,
	"spaceTop6": `WhyHostFormBlock3-spaceTop6-N2P0Q`,
	"spaceTop7": `WhyHostFormBlock3-spaceTop7-c2rja`,
	"padding1": `WhyHostFormBlock3-padding1-qeaU0`,
	"padding2": `WhyHostFormBlock3-padding2-zTTKT`,
	"padding3": `WhyHostFormBlock3-padding3-H_rsi`,
	"padding4": `WhyHostFormBlock3-padding4-lSmz9`,
	"padding5": `WhyHostFormBlock3-padding5-QYrWv`,
	"padding6": `WhyHostFormBlock3-padding6-BJKgH`,
	"padding7": `WhyHostFormBlock3-padding7-W1lwF`,
	"paddingTop1": `WhyHostFormBlock3-paddingTop1-H16fA`,
	"paddingTop2": `WhyHostFormBlock3-paddingTop2-JtQ0Q`,
	"paddingTop3": `WhyHostFormBlock3-paddingTop3-lxMEl`,
	"paddingTop4": `WhyHostFormBlock3-paddingTop4-bP84G`,
	"paddingTop5": `WhyHostFormBlock3-paddingTop5-NjzhR`,
	"paddingTop6": `WhyHostFormBlock3-paddingTop6-E9bYF`,
	"paddingTop7": `WhyHostFormBlock3-paddingTop7-SIDDd`,
	"noPadding": `WhyHostFormBlock3-noPadding-fZ8lb`,
	"textBold": `WhyHostFormBlock3-textBold-imstR`,
	"textBolder": `WhyHostFormBlock3-textBolder-POxyL`,
	"textNormal": `WhyHostFormBlock3-textNormal-faXcQ`,
	"spaceBottom20": `WhyHostFormBlock3-spaceBottom20-i35WO`,
	"spaceBottom10": `WhyHostFormBlock3-spaceBottom10-qkctv`,
	"marginNone": `WhyHostFormBlock3-marginNone-yl3fj`,
	"spaceBottom15": `WhyHostFormBlock3-spaceBottom15-YyWX5`,
	"marginTopNone": `WhyHostFormBlock3-marginTopNone-ipFFt`,
	"spaceTop11": `WhyHostFormBlock3-spaceTop11-BvF1R`,
	"spaceTop21": `WhyHostFormBlock3-spaceTop21-OyhP7`,
	"spaceTop20": `WhyHostFormBlock3-spaceTop20-lXBSx`,
	"spaceTop10": `WhyHostFormBlock3-spaceTop10-j1f5q`,
	"textDarkBlue": `WhyHostFormBlock3-textDarkBlue-UtGJV`,
	"textLightBlue": `WhyHostFormBlock3-textLightBlue-0QoGF`,
	"textLightSandleGreen": `WhyHostFormBlock3-textLightSandleGreen-gpQhz`,
	"textLightBrown": `WhyHostFormBlock3-textLightBrown-Xxy31`,
	"textMediumMaroon": `WhyHostFormBlock3-textMediumMaroon-hSArL`,
	"textBrown": `WhyHostFormBlock3-textBrown-kSZ4N`,
	"textMaroon": `WhyHostFormBlock3-textMaroon-et11l`,
	"textDarkBrown": `WhyHostFormBlock3-textDarkBrown-C6uVH`,
	"textMediumBrown": `WhyHostFormBlock3-textMediumBrown-PRPod`,
	"textSkyBlue": `WhyHostFormBlock3-textSkyBlue-ok0UF`,
	"textGray": `WhyHostFormBlock3-textGray-BCcQk`
};
module.exports = ___CSS_LOADER_EXPORT___;
